<template>
  <div>
    <b-form>
      <div class="premium-card shadow-sm mb-4">
        <div class="card-header-premium">
          <i class="fa fa-car mr-2"></i> DADOS DO VEÍCULO
        </div>
        <div class="p-3">
          <b-row>
            <b-col md="4">
              <b-form-group label="Placa" class="premium-form-group">
                <b-form-input v-model="local.placa" placeholder="AAA-0000" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="RNTC" class="premium-form-group">
                <b-form-input v-model="local.rntc" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="UF" class="premium-form-group">
                <b-form-select v-model="local.uf" :options="ufOptions" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'NfeTranspVeiculo',
  props: { 
    value: { type: Object, default: () => ({}) },
    podeEditar: { type: Boolean, default: false }
  },
  data() {
    return {
      local: this.initialLocal(),
      ufOptions: [/* TODO: populate from CDSUFNFE */],
      isUpdating: false
    }
  },
  watch: {
    value: { 
      handler() { 
        if (!this.isUpdating) {
          this.local = this.initialLocal()
        }
      }, 
      deep: true 
    },
    local: { 
      handler() { 
        if (!this.isUpdating) {
          this.emitInput()
        }
      }, 
      deep: true 
    }
  },
  methods: {
    initialLocal() {
      const v = this.value || {}
      return {
        placa: v.placa || v.TX_PLACA_VEIC_FRETE || '',
        rntc: v.rntc || v.TX_RNTC_VEIC_FRETE || '',
        uf: v.uf || v.ID_UF_PLACA_VEIC_FRETE || ''
      }
    },
    emitInput() {
      this.isUpdating = true
      const merged = Object.assign({}, this.value || {}, this.local)
      this.$emit('input', merged)
      this.$emit('changed')
      this.$nextTick(() => {
        this.isUpdating = false
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeTranspVeiculo.vue